const harmReductionLandingStyle = {
  /* ===== Page wrapper ===== */
  pageWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "1440px",
    margin: "0 auto",
    background: "#FFFFFF",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    color: "#000000",
    overflowX: "hidden",
    /* Override the global sticky navbar for this route only:
       the shared `.navbar-container` rule sets position:fixed (z-index 999),
       which we don't want on the campaign landing page. */
    "& .navbar-container": {
      position: "static",
      zIndex: "auto",
    },
  },

  /* ===== Section: Hero / Header 88 — image background, text overlaid ===== */
  heroSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "75px 64px",
    width: "100%",
    background: "#000000",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "0px",
    },
  },
  heroCard: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "0px 64px",
    width: "100%",
    maxWidth: "1280px",
    minHeight: "640px",
    backgroundColor: "#1a1a1a",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: "0px",
    boxSizing: "border-box",
    overflow: "hidden",
    "@media (max-width: 768px)": {
      padding: "48px 32px",
      minHeight: "480px",
    },
  },
  heroVideo: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0,
  },
  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0, 0, 0, 0.4)",
    zIndex: 1,
  },
  heroColumn: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "32px",
    maxWidth: "560px",
    boxSizing: "border-box",
  },
  heroContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
  },
  heroTitle: {
    fontFamily: "'Roboto Condensed', 'Roboto', sans-serif",
    fontWeight: 700,
    fontSize: "64px",
    lineHeight: "108%",
    color: "#FFFFFF",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "40px",
    },
  },
  heroSubtitle: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },
  heroActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "16px",
  },
  heroButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px",
    gap: "8px",
    background: "#2291C9",
    border: "1px solid #2291C9",
    borderRadius: "0px",
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "#1b7aa8",
    },
  },

  /* ===== Section: Layout 60 — intro two-col ===== */
  introSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "50px 64px",
    gap: "80px",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      padding: "40px 24px",
      gap: "32px",
    },
  },
  /* Dark variant of Layout 60 (used by the fentanyl section).
     Selectors are doubled (&& ...) to outrank the .introColLeft h2 /
     .introColRight p color rules, which share specificity and are
     defined later in the source. */
  introSectionDark: {
    background: "#000000",
    "&& h2": {
      color: "#FFFFFF",
    },
    "&& p": {
      color: "#FFFFFF",
    },
  },
  introContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "80px",
    width: "100%",
    maxWidth: "1280px",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: "32px",
    },
  },
  introColLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    flex: 1,
    "& h2": {
      fontFamily: "'Roboto'",
      fontWeight: 700,
      fontSize: "40px",
      lineHeight: "120%",
      color: "#000000",
      margin: 0,
    },
    "@media (max-width: 768px)": {
      "& h2": {
        fontSize: "28px",
      },
    },
  },
  introColRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    flex: 1,
    "& p": {
      fontFamily: "'Roboto'",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "150%",
      color: "#000000",
      margin: 0,
    },
  },
  introActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "16px",
  },
  introButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px",
    gap: "8px",
    background: "#2291C9",
    border: "1px solid #2291C9",
    borderRadius: "0px",
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "#1b7aa8",
    },
  },

  /* ===== Section: Layout 626 — features/signs grid ===== */
  featuresSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "75px 64px 112px",
    gap: "50px",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "40px 24px 60px",
      gap: "32px",
    },
  },
  featuresContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "38px",
    width: "100%",
    maxWidth: "1280px",
  },
  sectionTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    maxWidth: "768px",
  },
  sectionHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "120%",
    color: "#000000",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "28px",
    },
  },
  sectionText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
  },
  featureRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    gap: "24px",
    width: "100%",
    "@media (max-width: 900px)": {
      flexDirection: "column",
    },
  },
  featureItem: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    padding: "24px",
    flex: 1,
    minHeight: "260px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  featureOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 45%, rgba(0,0,0,0.8) 100%)",
    zIndex: 0,
  },
  featureContent: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  featureHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "140%",
    color: "#FFFFFF",
    margin: 0,
  },
  featureText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },
  /* Bottom content block inside Layout 626 — two columns on desktop
     (heading + copy left, accordion right), stacked on mobile. Mirrors the
     introContainer / ctaComponent two-col pattern used elsewhere. */
  bottomContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "80px",
    width: "100%",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: "32px",
    },
  },
  bottomContentColLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    flex: 1,
    minWidth: 0,
  },
  bottomContentColRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
    minWidth: 0,
    width: "100%",
  },
  bottomHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "32px",
    lineHeight: "130%",
    color: "#000000",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "24px",
    },
  },
  bottomText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
  },
  bottomTextLink: {
    color: "#2291C9",
    textDecoration: "underline",
    cursor: "pointer",
    /* keep the phone number intact — wrap it as a whole to the next line
       rather than splitting it across the line break */
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#2291C9",
    },
  },

  /* ===== Accordion: "If you notice these signs, take action" ===== */
  accordionList: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    borderBottom: "1px solid #000000",
  },
  accordionItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  accordionQuestion: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "24px",
    padding: "20px 0px",
    width: "100%",
    borderTop: "1px solid #000000",
    /* reset native button styles */
    background: "none",
    border: "none",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "#000000",
    textAlign: "left",
    cursor: "pointer",
    font: "inherit",
    appearance: "none",
    outline: "none",
  },
  accordionQuestionText: {
    flexGrow: 1,
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#000000",
  },
  accordionIcon: {
    flexShrink: 0,
    width: "32px",
    height: "32px",
    color: "#000000",
  },
  accordionAnswer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "16px",
    padding: "0px 0px 24px",
    width: "100%",
  },
  accordionPoints: {
    margin: 0,
    paddingLeft: "20px",
    maxWidth: "768px",
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#000000",
    "& li": {
      marginBottom: "4px",
    },
  },

  /* ===== Section: Stats 28 ===== */
  statsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0px 64px 112px",
    gap: "80px",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "0px 24px 60px",
    },
  },
  statsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "41px",
    width: "100%",
    maxWidth: "1280px",
  },
  statsGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    gap: "32px",
    width: "100%",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  statCard: {
    position: "relative",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    padding: "32px",
    flex: 1,
    minHeight: "280px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: "0px",
    overflow: "hidden",
  },
  statOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.82) 100%)",
    zIndex: 0,
  },
  statContent: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    width: "100%",
  },
  statNumber: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "140%",
    color: "#FFFFFF",
    margin: 0,
  },
  statLabel: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },

  /* ===== Section: CTA 17 — white CTA ===== */
  ctaSection: {
    position: "relative",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
  },
  ctaContainer: {
    padding: "89px 80px",
    "@media (max-width: 768px)": {
      padding: "60px 24px",
    },
  },
  ctaComponent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "80px",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: "32px",
    },
  },
  ctaColLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    flex: 1,
    "& h2": {
      fontFamily: "'Roboto'",
      fontWeight: 700,
      fontSize: "48px",
      lineHeight: "120%",
      color: "#000000",
      margin: 0,
    },
    "@media (max-width: 768px)": {
      "& h2": {
        fontSize: "32px",
      },
    },
  },
  ctaColRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    flex: 1,
    "& p": {
      fontFamily: "'Roboto'",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "150%",
      color: "#000000",
      margin: 0,
    },
  },
  ctaLink: {
    color: "#2291C9",
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
      color: "#2291C9",
    },
  },
  ctaActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "16px",
  },
  ctaButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px",
    gap: "8px",
    background: "#2291C9",
    border: "1px solid #2291C9",
    borderRadius: "0px",
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "#1b7aa8",
    },
  },

  /* ===== Section: Before you use — heading left, 3 list items right ===== */
  beforeUseSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "50px 64px",
    gap: "80px",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      padding: "40px 24px",
      gap: "32px",
    },
  },
  beforeUseContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "48px",
    width: "100%",
    maxWidth: "1280px",
  },
  beforeUseColLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    width: "100%",
    maxWidth: "768px",
  },
  beforeUseTagline: {
    fontFamily: "'Roboto'",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
  },
  beforeUseHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "120%",
    color: "#000000",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "28px",
    },
  },
  beforeUseDescription: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
  },
  beforeUseLeftActions: {
    marginTop: "16px",
  },
  beforeUseLeftButton: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px",
    gap: "8px",
    background: "#2291C9",
    border: "1px solid #2291C9",
    borderRadius: "0px",
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "#1b7aa8",
    },
  },
  beforeUseColRight: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    gap: "0px",
    borderTop: "1px solid #AAAAAA",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      borderTop: "none",
    },
  },
  beforeUseItem: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    flex: 1,
    padding: "32px",
    /* Vertical divider between items (skip the first) */
    "&:not(:first-child)": {
      borderLeft: "1px solid #AAAAAA",
    },
    "@media (max-width: 600px)": {
      borderTop: "1px solid #AAAAAA",
      "&:not(:first-child)": {
        borderLeft: "none",
      },
    },
  },
  beforeUseIcon: {
    width: "100px",
    height: "100px",
    objectFit: "contain",
    flexShrink: 0,
    display: "block",
  },
  beforeUseItemContent: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  beforeUseItemHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "140%",
    color: "#000000",
    margin: 0,
  },
  beforeUseItemText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
  },
  beforeUseItemLink: {
    color: "#2291C9",
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
      color: "#2291C9",
    },
  },

  /* ===== Section: Testimonial 33 — heading left, quote grid right, photo bg ===== */
  testimonialSection: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 64px 80px",
    width: "100%",
    backgroundColor: "#0d0d0d",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "24px 24px 48px",
    },
  },
  testimonialOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0, 0, 0, 0.45)",
    zIndex: 0,
  },
  testimonialContainer: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    gap: "48px",
    width: "100%",
    maxWidth: "1280px",
    boxSizing: "border-box",
  },
  /* White header section (outside the black cards container) */
  testimonialHeaderSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "80px 64px 40px",
    width: "100%",
    background: "#FFFFFF",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "48px 24px 24px",
    },
  },
  testimonialHeaderInner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    width: "100%",
    maxWidth: "1280px",
  },
  testimonialHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "120%",
    color: "#000000",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "28px",
    },
  },
  testimonialSubheading: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#000000",
    margin: 0,
    maxWidth: "600px",
  },
  testimonialLeftActions: {
    marginTop: "8px",
  },
  testimonialColRight: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridAutoRows: "1fr",
    gap: "24px",
    boxSizing: "border-box",
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr",
    },
  },
  testimonialCard: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    padding: "32px",
    gap: "24px",
    background: "transparent",
    border: "1px solid #FFFFFF",
    borderRadius: "0px",
    alignItems: "flex-start",
  },
  testimonialQuote: {
    fontFamily: "'Noto Serif', serif",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },
  testimonialAttribution: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginTop: "auto",
  },
  testimonialName: {
    fontFamily: "'Roboto'",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },

  /* ===== Bottom band: Cocaine deaths + Quitting CTA, side by side ===== */
  bottomBandSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "75px 64px",
    width: "100%",
    background: "#000000",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "40px 24px",
    },
  },
  bottomBandRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "80px",
    width: "100%",
    maxWidth: "1280px",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: "48px",
    },
  },
  statsLayoutColLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    flex: 1,
    "& h2": {
      fontFamily: "'Roboto'",
      fontWeight: 700,
      fontSize: "40px",
      lineHeight: "120%",
      color: "#FFFFFF",
      margin: 0,
    },
    "@media (max-width: 768px)": {
      "& h2": {
        fontSize: "28px",
      },
    },
  },
  bottomBandText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },
  statsNumberGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: "8px 0px",
    gap: "24px",
    width: "100%",
    "@media (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  // `& h2` here is a descendant selector (.statsNumberItem h2) that ties the
  // specificity of the `.statsLayoutColLeft h2` rule (which pins headings to
  // 40px) and wins on source order, so the stat numbers render at 96px without
  // needing !important. The .statsNumberValue class alone (0-1-0) loses to
  // .statsLayoutColLeft h2 (0-1-1), which is why the earlier attempt did nothing.
  statsNumberItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    flex: 1,
    "& h2": {
      fontFamily: "'Roboto'",
      fontWeight: 700,
      fontSize: "96px",
      lineHeight: "120%",
      color: "#FFFFFF",
      margin: 0,
    },
    "@media (max-width: 768px)": {
      "& h2": {
        fontSize: "64px",
      },
    },
    "@media (max-width: 480px)": {
      "& h2": {
        fontSize: "48px",
      },
    },
  },
  statsNumberValue: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    lineHeight: "120%",
    color: "#FFFFFF",
    margin: 0,
  },
  statsNumberLabel: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },

  /* ===== CTA 5 — Quitting CTA (right side of bottom band) ===== */
  bottomCtaColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    flex: 1,
  },
  bottomCtaContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
  },
  bottomCtaHeading: {
    fontFamily: "'Roboto'",
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "120%",
    color: "#FFFFFF",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "32px",
    },
  },
  bottomCtaText: {
    fontFamily: "'Roboto'",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "150%",
    color: "#FFFFFF",
    margin: 0,
  },
};

export default harmReductionLandingStyle;
